export const CAR_OPTION_INFO = [
	{
		optionCd: '010',
		optionName: '선루프',
	},
	{
		optionCd: '001',
		optionName: '헤드램프',
	},
	{
		optionCd: '029',
		optionName: '헤드램프(HID)',
	},
	{
		optionCd: '075',
		optionName: '헤드램프(LED)',
	},
	{
		optionCd: '059',
		optionName: '파워 전동 트렁크',
	},
	{
		optionCd: '080',
		optionName: '고스트 도어 클로징',
	},
	{
		optionCd: '024',
		optionName: '전동접이 사이드 미러',
	},
	{
		optionCd: '017',
		optionName: '알루미늄 휠',
	},
	{
		optionCd: '062',
		optionName: '루프랙',
	},
	{
		optionCd: '082',
		optionName: '열선 스티어링 휠',
	},
	{
		optionCd: '083',
		optionName: '전동 조절 스티어링 휠',
	},
	{
		optionCd: '084',
		optionName: '패들 시프트',
	},
	{
		optionCd: '031',
		optionName: '스티어링 휠 리모컨',
	},
	{
		optionCd: '030',
		optionName: 'ECM 룸미러',
	},
	{
		optionCd: '074',
		optionName: '하이패스',
	},
	{
		optionCd: '006',
		optionName: '파워 도어록',
	},
	{
		optionCd: '008',
		optionName: '파워 스티어링 휠',
	},
	{
		optionCd: '007',
		optionName: '파워 윈도우',
	},
	{
		optionCd: '002',
		optionName: '에어백',
	},
	{
		optionCd: '026',
		optionName: '에어백(운전석)',
	},
	{
		optionCd: '027',
		optionName: '에어백(동승석)',
	},
	{
		optionCd: '020',
		optionName: '에어백(사이드)',
	},
	{
		optionCd: '056',
		optionName: '에어백(커튼)',
	},
	{
		optionCd: '001',
		optionName: '브레이크 잠김 방지(ABS)',
	},
	{
		optionCd: '019',
		optionName: '미끄럼 방지(TCS)',
	},
	{
		optionCd: '055',
		optionName: '차체 자세 제어장치(ESC)',
	},
	{
		optionCd: '033',
		optionName: '타이어 공기압센서(TPMS)',
	},
	{
		optionCd: '088',
		optionName: '차선이탈 경보 시스템(LDWS)',
	},
	{
		optionCd: '002',
		optionName: '전자제어 서스펜션(ECS)',
	},
	{
		optionCd: '003',
		optionName: '주차감지센서',
	},
	{
		optionCd: '085',
		optionName: '주차감지센서(전방)',
	},
	{
		optionCd: '032',
		optionName: '주차감지센서(후방)',
	},
	{
		optionCd: '086',
		optionName: '후측방 경보 시스템',
	},
	{
		optionCd: '058',
		optionName: '후방 카메라',
	},
	{
		optionCd: '087',
		optionName: '360도 어라운드 뷰',
	},
	{
		optionCd: '004',
		optionName: '크루즈 컨트롤',
	},
	{
		optionCd: '068',
		optionName: '크루즈 컨트롤(일반)',
	},
	{
		optionCd: '079',
		optionName: '크루즈 컨트롤(어댑티브)',
	},
	{
		optionCd: '095',
		optionName: '헤드업 디스플레이(HUD)',
	},
	{
		optionCd: '094',
		optionName: '전자식 주차브레이크(EPB)',
	},
	{
		optionCd: '023',
		optionName: '자동 에어컨',
	},
	{
		optionCd: '057',
		optionName: '스마트키',
	},
	{
		optionCd: '015',
		optionName: '무선도어 잠금장치',
	},
	{
		optionCd: '081',
		optionName: '레인센서',
	},
	{
		optionCd: '097',
		optionName: '오토 라이트',
	},
	{
		optionCd: '005',
		optionName: '커튼/블라인드',
	},
	{
		optionCd: '092',
		optionName: '커튼/블라인드(뒷좌석)',
	},
	{
		optionCd: '093',
		optionName: '커튼/블라인드(후방)',
	},
	{
		optionCd: '005',
		optionName: '내비게이션',
	},
	{
		optionCd: '004',
		optionName: '앞좌석 AV 모니터',
	},
	{
		optionCd: '054',
		optionName: '뒷좌석 AV 모니터',
	},
	{
		optionCd: '096',
		optionName: '블루투스',
	},
	{
		optionCd: '003',
		optionName: 'CD 플레이어',
	},
	{
		optionCd: '072',
		optionName: 'USB 단자',
	},
	{
		optionCd: '071',
		optionName: 'AUX 단자',
	},
	{
		optionCd: '014',
		optionName: '가죽시트',
	},
	{
		optionCd: '006',
		optionName: '전동시트',
	},
	{
		optionCd: '021',
		optionName: '전동시트(운전석)',
	},
	{
		optionCd: '035',
		optionName: '전동시트(동승석)',
	},
	{
		optionCd: '089',
		optionName: '전동시트(뒷좌석)',
	},
	{
		optionCd: '007',
		optionName: '열선시트',
	},
	{
		optionCd: '022',
		optionName: '열선시트(앞좌석)',
	},
	{
		optionCd: '063',
		optionName: '열선시트(뒷좌석)',
	},
	{
		optionCd: '008',
		optionName: '메모리 시트',
	},
	{
		optionCd: '051',
		optionName: '메모리 시트(운전석)',
	},
	{
		optionCd: '078',
		optionName: '메모리 시트(동승석)',
	},
	{
		optionCd: '009',
		optionName: '통풍시트',
	},
	{
		optionCd: '034',
		optionName: '통풍시트(운전석)',
	},
	{
		optionCd: '077',
		optionName: '통풍시트(동승석)',
	},
	{
		optionCd: '090',
		optionName: '통풍시트(뒷좌석)',
	},
	{
		optionCd: '091',
		optionName: '마사지 시트',
	},
];

const Exterior = [
	{ optionCd: '010', optionNm: '선루프' },
	{ optionCd: '029', optionNm: '헤드램프(HID)' },
	{ optionCd: '059', optionNm: '파워 전동 트렁크' },
	{ optionCd: '082', optionNm: '열선 스티어링 휠' },
	{ optionCd: '083', optionNm: '전동 조절 스티어링 휠' },
	{ optionCd: '024', optionNm: '전동접이 사이드 미러' },
];

const Safety = [
	{
		optionCd: '003',
		optionNm: '주차감지센서',
		selectType: 'CHECKBOX',
		subOptions: [
			{ optionCd: '085', optionNm: '전방' },
			{ optionCd: '032', optionNm: '후방' },
		],
	},
	{ optionCd: '086', optionNm: '후측방 경보 시스템' },
	{ optionCd: '058', optionNm: '후방 카메라' },
	{ optionCd: '087', optionNm: '360도 어라운드 뷰' },
	{ optionCd: '088', optionNm: '차선이탈 경보 시스템' },
];

const Multimedia = [
	{
		optionCd: '095',
		optionNm: '헤드업 디스플레이(HUD)',
	},
	{ optionCd: '023', optionNm: '자동 에어컨' },
	{ optionCd: '057', optionNm: '스마트키' },
	{
		optionCd: '005',
		optionNm: '내비게이션',
		selectType: 'RADIO',
		subOptions: [
			{ optionCd: '005', optionNm: '순정' },
			{ optionCd: 'CUSTOM_002', optionNm: '비순정' },
		],
	},
	{
		optionCd: '079',
		optionNm: '크루즈 컨트롤',
		selectType: 'RADIO',
		subOptions: [
			{ optionCd: '068', optionNm: '일반' },
			{ optionCd: '079', optionNm: '어댑티브' },
		],
	},
];

const Seat = [
	{
		optionCd: '007',
		optionNm: '열선시트',
		selectType: 'CHECKBOX',
		subOptions: [
			{ optionCd: '022', optionNm: '앞좌석' },
			{ optionCd: '063', optionNm: '뒷좌석' },
		],
	},
	{
		optionCd: '008',
		optionNm: '메모리 시트',
		selectType: 'CHECKBOX',
		subOptions: [
			{ optionCd: '051', optionNm: '운전석' },
			{ optionCd: '078', optionNm: '동승석' },
		],
	},
	{
		optionCd: '006',
		optionNm: '전동시트',
		selectType: 'CHECKBOX',
		subOptions: [
			{ optionCd: '021', optionNm: '운전석' },
			{ optionCd: '035', optionNm: '동승석' },
			{ optionCd: '089', optionNm: '뒷좌석' },
		],
	},
	{
		optionCd: '009',
		optionNm: '통풍시트',
		selectType: 'CHECKBOX',
		subOptions: [
			{ optionCd: '034', optionNm: '운전석' },
			{ optionCd: '077', optionNm: '동승석' },
			{ optionCd: '090', optionNm: '뒷좌석' },
		],
	},
];

export const OPTION_MAP = {
	Exterior,
	Safety,
	Multimedia,
	Seat,
};

export default null;
